import { useEffect, useRef } from 'react';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import LoginStep from './_variants/login-step.component';
import PinConfirmationStep from './_variants/pin-confirmation-step.component';
import ForgotPasswordCpfStep from './_variants/forgot-password-cpf-step.component';
import ForgotPasswordStep from './_variants/forgot-password-step.component';
import type { SignInModalProps } from './_types/sign-in-modal.types';

import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { ProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.component';
import { LoginAnalyticsEnum } from '@/types/enums/analytics/login/login-analytics.enum';
import { trackLoginModalEvent } from '@/utils/auth/login-analytics.util';

export const SignInModal = ({ isOpen, setIsOpen, initialStep }: SignInModalProps) => {
  const wasOpenRef = useRef(false);

  useEffect(() => {
    if (isOpen && !wasOpenRef.current && (initialStep || StepKeys.LOGIN) === StepKeys.LOGIN) {
      trackLoginModalEvent(LoginAnalyticsEnum.LOGIN_VIEW_MODAL);
    }
    wasOpenRef.current = isOpen;
  }, [isOpen, initialStep]);

  return (
    <ProgressiveModal
      open={isOpen}
      data-testid={DataTestIdEnum.SIGN_IN_MODAL}
      initialKey={initialStep || StepKeys.LOGIN}
      className="sm:bg-transparent border-none outline-none outline-offset-0"
      handleClose={() => setIsOpen(false)}
      hasHeader={true}
      onInteractOutside={({ event }) => event.preventDefault()}
      onOpenAutoFocus={({ event }) => event.preventDefault()}
      onCloseAutoFocus={({ event }) => event.preventDefault()}
      onEscapeKeyDown={({ currentKey }) => {
        if (currentKey === StepKeys.LOGIN) {
          trackLoginModalEvent(LoginAnalyticsEnum.LOGIN_CLOSE_MODAL);
        }
      }}
    >
      <LoginStep key={StepKeys.LOGIN} />
      <PinConfirmationStep key={StepKeys.PIN_CONFIRMATION} />
      <ForgotPasswordCpfStep key={StepKeys.FORGOT_PASSWORD_CPF} />
      <ForgotPasswordStep key={StepKeys.FORGOT_PASSWORD} />
    </ProgressiveModal>
  );
};
